import type { AreaCatalog } from '../area';
import type { feed as en } from '../en/feed';

export const feed = {
  'feed.filter.all': 'Alle',
  'feed.filter.flagged': 'Markiert',
  'feed.filter.critical': 'Kritisch',
  'feed.filter.byLevel': 'Nach Stufe filtern',
  'feed.filter.activityByLevel': 'Verlauf nach Stufe filtern',
  'feed.signal.flagged': 'markiert',
  'feed.signal.critical': 'kritisch',
  'feed.level.info': 'Info',
  'feed.level.notice': 'Hinweis',
  'feed.level.warning': 'Warnung',
  'feed.level.critical': 'kritisch',

  'feed.trail.heading': 'Verlauf',
  'feed.trail.empty': 'Noch kein Verlauf. Jeder Schritt an dieser Aufgabe landet hier.',
  'feed.trail.scope.label': 'Verlauf zeigen von',
  'feed.trail.scope.own': 'Diese Aufgabe',
  'feed.trail.scope.subItems': 'Mit Unteraufgaben',
  'feed.trail.emptyAtLevel':
    'Nichts auf dieser Stufe. Stell den Filter niedriger, um auch Routineschritte zu sehen.',

  'feed.page.title': 'Aktivität',
  'feed.page.placeholder': 'Öffne einen Eintrag, um ihn hier zu lesen.',
  'feed.empty': 'Noch nichts da.',
  'feed.emptyAtLevel': 'Nichts auf dieser Stufe und keine offenen Anfragen.',
  'feed.hideMuted': 'Stummgeschaltete ausblenden',
  'feed.showAll': 'Alle anzeigen ({count})',
  'feed.unread': 'Ungelesen',
  'feed.markAllRead': 'Alle als gelesen markieren',
  'feed.undoMarkAllRead': 'Rückgängig: alle als gelesen markieren',
  'feed.undo': 'Rückgängig',
  'feed.markReadFailed': 'Als gelesen markieren hat nicht geklappt.',
  'feed.undoFailed': 'Rückgängig machen hat nicht geklappt.',
  'feed.askChip': 'Anfrage',
  'feed.row.aPlan': 'ein Plan',
  'feed.row.open': 'Details zu {title} öffnen',
  'feed.row.openUntitled': 'Details zum Eintrag öffnen',
  'feed.row.openBurst': {
    one: '{count} Änderung an {title} öffnen',
    other: '{count} Änderungen an {title} öffnen',
  },
  'feed.row.openBurstUntitled': {
    one: '{count} Änderung an dieser Aufgabe öffnen',
    other: '{count} Änderungen an dieser Aufgabe öffnen',
  },
  'feed.row.acknowledge': 'Zur Kenntnis nehmen',
  'feed.row.acknowledgeItem': '{title} zur Kenntnis nehmen',
  'feed.row.acknowledgeUntitled': 'Diese Aufgabe zur Kenntnis nehmen',
  'feed.row.notifications': 'Benachrichtigungen für {title}',
  'feed.row.notificationsUntitled': 'Benachrichtigungen für diese Aufgabe',
  'feed.notify.heading': 'Benachrichtige mich zu dieser Aufgabe',
  'feed.notify.subscribe': 'Abonnieren',
  'feed.notify.default': 'Standard',
  'feed.notify.hide': 'Stummschalten',

  'feed.clipped.done': 'Eine Abhängigkeit, die du nicht sehen kannst, wurde abgeschlossen',
  'feed.clipped.cancelled': 'Eine Abhängigkeit, die du nicht sehen kannst, wurde abgebrochen',
  'feed.clipped.reopened': 'Eine Abhängigkeit, die du nicht sehen kannst, wurde wieder geöffnet',
  'feed.clipped.endsAfter':
    'Eine Abhängigkeit, die du nicht sehen kannst, endet jetzt nach dem Ende dieser Aufgabe',

  'feed.ask.contactRequest': 'Kontaktanfrage',
  'feed.ask.wantsContact': '{actor} möchte dein Kontakt sein',
  'feed.ask.addedYou': '{adder} hat dich zu {group} hinzugefügt',
  'feed.ask.youWereAdded': 'Du wurdest zu {group} hinzugefügt',
  'feed.ask.accept': 'Annehmen',
  'feed.ask.decline': 'Ablehnen',
  'feed.ask.takeUp': 'Annehmen',
  'feed.ask.options': 'Optionen für {name}',
  'feed.ask.block': 'Sperren',
  'feed.ask.blockRequest':
    'Lehnt diese Anfrage ab. Bis du entsperrst, geht keine Anfrage zwischen euch durch.',
  'feed.ask.blockInvitations':
    'Blendet die Einladungen dieser Person aus. Bis du entsperrst, geht keine Anfrage zwischen euch durch.',
  'feed.decision.asks': '{actor} fragt an: {detail}',
  'feed.decision.proposes': '{actor} schlägt vor: {detail}',
  'feed.offer.you': '{actor} hat dir {item} zugewiesen {role}',
  'feed.event.mentioned': '{actor} hat dich in {item} genannt',
  'feed.offer.group': '{actor} hat {group} {item} zugewiesen {role}',
  'feed.offer.role.requester': 'Verantwortlich',
  'feed.offer.role.contributor': 'Zuständig',

  'feed.names.someone': 'Jemand',
  'feed.names.two': '{first} und {second}',
  'feed.names.more': {
    one: '{first}, {second} und {count} weitere Person',
    other: '{first}, {second} und {count} weitere',
  },
  'feed.burst.made': {
    one: '{count} Änderung von {names}{summary}',
    other: '{count} Änderungen von {names}{summary}',
  },
  'feed.burst.changes': { one: '{count} Änderung', other: '{count} Änderungen' },

  'feed.detail.proposedChange': 'Änderungsvorschlag',
  'feed.detail.changes': 'Änderungen',
  'feed.detail.event': 'Ereignis',
  'feed.detail.on': 'Betrifft',
  'feed.detail.proposedBy': 'Vorgeschlagen von',
  'feed.detail.via': 'über {proposal}',
  'feed.detail.change': 'Änderung',
  'feed.detail.status': 'Status',
  'feed.detail.who': 'Wer',
  'feed.detail.when': 'Wann',
  'feed.detail.level': 'Stufe',
  'feed.detail.openChange': 'Diese Änderung öffnen',
  'feed.detail.ownerOnly': 'Nur die Verantwortlichen der Aufgabe können das entscheiden.',
  'feed.detail.accept': 'Annehmen',
  'feed.detail.decline': 'Ablehnen',
  'feed.changeStatus.pending': 'wartet auf eine Entscheidung',
  'feed.changeStatus.applied': 'angewendet',
  'feed.changeStatus.declined': 'abgelehnt',
  'feed.changeStatus.superseded': 'ersetzt',
  'feed.diff.aligned': 'der aktuelle Wert stimmt schon überein',
  'feed.diff.adapted': 'der aktuelle Wert hat sich seit dem Vorschlag geändert',
  'feed.diff.unmet': 'noch nicht erfüllt',

  'feed.where.removed': '(entfernte Aufgabe)',

  'feed.change.phase.open': 'Zu erledigen',
  'feed.change.phase.active': 'In Arbeit',
  'feed.change.phase.done': 'Fertig',
  'feed.change.phase.cancelled': 'Abgebrochen',
  'feed.entry.lead.flow': 'Ablauf {name}',
  'feed.entry.lead.anyFlow': 'Ein Ablauf',
  'feed.entry.join': '{first} {second}',
  'feed.entry.field.line': 'Punkt',
  'feed.entry.line.ticked': 'abgehakt',
  'feed.entry.line.unticked': 'nicht mehr abgehakt',
  'feed.entry.line.moved': 'verschoben',
  'feed.entry.line.promoted': 'Punkt zur Unteraufgabe gemacht',
  'feed.entry.line.demoted': 'Unteraufgabe zum Punkt gemacht',
  'feed.entry.cleared': 'geleert',
  'feed.entry.field.title': 'Titel',
  'feed.entry.field.description': 'Beschreibung',
  'feed.entry.field.acceptanceCriteria': 'Abnahmekriterien',
  'feed.entry.field.note': 'Notiz',
  'feed.entry.field.priority': 'Priorität',
  'feed.entry.field.visibility': 'Sichtbarkeit',
  'feed.entry.field.access': 'Zugriff',
  'feed.entry.field.share': 'Anteil',
  'feed.entry.field.allocation': 'Einsatz',
  'feed.entry.field.allocationUnit': 'Einheit des Einsatzes',
  'feed.entry.field.allocationCadence': 'Rhythmus des Einsatzes',
  'feed.entry.field.estimate': 'Schätzung',
  'feed.entry.field.estimateUnit': 'Einheit der Schätzung',
  'feed.entry.field.budget': 'Budget',
  'feed.entry.field.budgetCurrency': 'Währung',
  'feed.entry.field.budgetCadence': 'Rhythmus des Budgets',
  'feed.entry.field.start': 'Beginn',
  'feed.entry.field.startAnchor': 'Bezugsaufgabe des Beginns',
  'feed.entry.field.startOffset': 'Abstand zum Beginn',
  'feed.entry.field.startOffsetUnit': 'Einheit des Abstands zum Beginn',
  'feed.entry.field.end': 'Ende',
  'feed.entry.field.endAnchor': 'Bezugsaufgabe des Endes',
  'feed.entry.field.endOffset': 'Abstand zum Ende',
  'feed.entry.field.endOffsetUnit': 'Einheit des Abstands zum Ende',
  'feed.entry.field.duration': 'Dauer',
  'feed.entry.field.durationUnit': 'Einheit der Dauer',
  'feed.entry.field.cadence': 'Rhythmus',
  'feed.entry.field.cadenceUnit': 'Einheit des Rhythmus',
  'feed.entry.seat.requester': 'Verantwortlich',
  'feed.entry.seat.contributor': 'Zuständig',
  'feed.entry.relation.dependsOn': 'Hängt ab von',
  'feed.entry.relation.neededBy': 'Davon hängt ab',
  'feed.entry.relation.partOf': 'Teil von',
  'feed.entry.relation.subItems': 'Unteraufgaben',
  'feed.entry.relation.related': 'Verwandt',
  'feed.entry.role.viewer': 'Betrachtende',
  'feed.entry.role.member': 'Mitglied',
  'feed.entry.role.owner': 'Verwaltende',
  'feed.entry.priority.must': 'muss',
  'feed.entry.priority.should': 'soll',
  'feed.entry.priority.could': 'kann',
  'feed.entry.visibility.open': 'Für alle offen',
  'feed.entry.visibility.protected': 'Privat',
  'feed.entry.access.inherits': 'Erbt von übergeordneten Aufgaben',
  'feed.entry.access.broken': 'Vererbung unterbrochen',
  'feed.entry.module.resources': 'Ressourcen',
  'feed.entry.module.schedule': 'Zeitplan',
  'feed.entry.unit.fte': 'FTE',
  'feed.entry.unit.percent': '%',
  'feed.entry.unit.hours': 'Stunden',
  'feed.entry.unit.days': 'Tage',
  'feed.entry.unit.weeks': 'Wochen',
  'feed.entry.unit.months': 'Monate',
  'feed.entry.cadence.oneTime': 'einmalig',
  'feed.entry.cadence.perWeek': 'pro Woche',
  'feed.entry.cadence.perMonth': 'pro Monat',
  'feed.entry.cadence.perYear': 'pro Jahr',

  'feed.action.created': 'erstellt',
  'feed.action.statusChanged': 'verschoben',
  'feed.action.committed': 'zugesagt',
  'feed.action.phaseChanged': 'verschoben',
  'feed.action.tendered': 'eingereicht',
  'feed.action.tenderRetracted': 'zurückgenommen',
  'feed.action.dissolved': 'abgebrochen',
  'feed.action.revived': 'wieder geöffnet',
  'feed.action.activityDeclared': 'angegeben',
  'feed.action.concluded': 'fertiggestellt',
  'feed.action.cancelled': 'abgebrochen',
  'feed.action.reopened': 'wieder geöffnet',
  'feed.action.seatOffered': 'angeboten',
  'feed.action.seatTaken': 'übernommen',
  'feed.action.seatDeclined': 'abgelehnt',
  'feed.action.seatWithdrawn': 'Angebot zurückgezogen',
  'feed.action.seatAccepted': 'Angebot angenommen',
  'feed.action.seatProposedRequester': 'Verantwortlich vorgeschlagen',
  'feed.action.seatProposedContributor': 'Zuständig vorgeschlagen',
  'feed.action.seatAssignedRequester': 'Verantwortlich zugewiesen',
  'feed.action.seatAssignedContributor': 'Zuständig zugewiesen',
  'feed.action.seatAcceptedRequester': 'Verantwortlich angenommen',
  'feed.action.seatAcceptedContributor': 'Zuständig angenommen',
  'feed.action.seatAcceptedForRequester': 'Verantwortlich für die Gruppe angenommen',
  'feed.action.seatAcceptedForContributor': 'Zuständig für die Gruppe angenommen',
  'feed.action.seatTookUpRequester': 'Verantwortlich übernommen',
  'feed.action.seatTookUpContributor': 'Zuständig übernommen',
  'feed.action.seatRefusedRequester': 'Verantwortlich abgelehnt',
  'feed.action.seatRefusedContributor': 'Zuständig abgelehnt',
  'feed.action.pushRuleSet': 'Regeln zum Einsetzen festgelegt',
  'feed.action.reassigned': 'neu eingesetzt',
  'feed.action.fieldChanged': 'bearbeitet',
  'feed.action.contentEdited': 'bearbeitet',
  'feed.action.commented': 'kommentiert',
  'feed.action.acknowledged': 'zur Kenntnis genommen',
  'feed.action.resolved': 'Bewertung zurückgenommen',
  'feed.action.accepted': 'abgenommen',
  'feed.action.disputed': 'Abnahme verweigert',
  'feed.action.closed': 'abgeschlossen',
  'feed.action.aborted': 'abgebrochen',
  'feed.action.dependencyAdded': 'Abhängigkeit hinzugefügt',
  'feed.action.dependencyRemoved': 'Abhängigkeit entfernt',
  'feed.action.reparented': 'verschoben',
  'feed.action.relationshipAdded': 'verknüpft',
  'feed.action.relationshipRemoved': 'Verknüpfung entfernt',
  'feed.action.relationshipProposed': 'Verknüpfung angefragt',
  'feed.action.relationshipAccepted': 'Verknüpfung angenommen',
  'feed.action.relationshipRejected': 'Verknüpfung abgelehnt',
  'feed.action.shared': 'freigegeben',
  'feed.action.unshared': 'Freigabe widerrufen',
  'feed.action.accessRequested': 'Zugriff angefragt',
  'feed.action.stageAdvanced': 'eine Phase vorgerückt',
  'feed.action.memberAdded': 'Mitglied hinzugefügt',
  'feed.action.memberRemoved': 'Mitglied entfernt',
  'feed.action.nestingProposed': 'Unterordnung vorgeschlagen',
  'feed.action.nestingAccepted': 'Unterordnung angenommen',
  'feed.action.nestingSevered': 'Unterordnung aufgehoben',
  'feed.action.memberProposed': 'um Beitritt gebeten',
  'feed.action.memberAccepted': 'beigetreten',
  'feed.action.memberDeclined': 'Beitritt abgelehnt',
  'feed.action.grantIssued': 'Zugriff freigegeben',
  'feed.action.grantRevoked': 'Zugriff widerrufen',
  'feed.action.moduleEnabled': 'Abschnitt eingeschaltet',
  'feed.action.moduleDisabled': 'Abschnitt ausgeschaltet',
  'feed.action.moduleAdded': 'Abschnitt hinzugefügt',
  'feed.action.moduleRemoved': 'Abschnitt entfernt',
  'feed.action.tagDefined': 'Zustand definiert',
  'feed.action.tagApplied': 'Zustand gesetzt',
  'feed.action.tagCleared': 'Zustand aufgehoben',
  'feed.action.factQualified': 'Fakt eingeordnet',
  'feed.action.factAdopted': 'gesetzt',
  'feed.action.factContained': 'nicht betroffen von',
  'feed.action.factContainedAlone': 'nicht betroffen',
  'feed.action.flowFinding': 'Befund gemeldet',
  'feed.action.factCrossed': 'Grenze überschritten',
  'feed.action.viewDefined': 'Board oder Ansicht gespeichert',
  'feed.action.viewUpdated': 'Board oder Ansicht aktualisiert',
  'feed.action.viewDeleted': 'Board gelöscht',
  'feed.action.viewRetired': 'Board oder Ansicht archiviert',
  'feed.action.viewRestored': 'Board oder Ansicht wiederhergestellt',
  'feed.action.viewAccessGranted': 'Board oder Ansicht geteilt',
  'feed.action.viewAccessRevoked': 'Teilen beendet',
  'feed.action.proposalCreated': 'Vorschlag entworfen',
  'feed.action.proposalPublished': 'Vorschlag veröffentlicht',
  'feed.action.proposalWithdrawn': 'Vorschlag zurückgezogen',
  'feed.action.changeProposed': 'Änderung vorgeschlagen',
  'feed.action.changeApplied': 'Änderung angewendet',
  'feed.action.changeDeclined': 'Änderungsvorschlag abgelehnt',
  'feed.action.changeSuperseded': 'Änderungsvorschlag ersetzt',
  'feed.action.planCreated': 'Plan erstellt',
  'feed.action.proposalAddedToPlan': 'Vorschlag zum Plan hinzugefügt',
  'feed.action.planPublished': 'Plan veröffentlicht',
  'feed.action.definitionDefined': 'Ablauf definiert',
  'feed.action.definitionChanged': 'Definition geändert',
  'feed.action.definitionArchived': 'Definition archiviert',
  'feed.action.definitionUnarchived': 'Archivierung aufgehoben',
  'feed.action.definitionAccessGranted': 'Zugriff auf Ablauf freigegeben',
  'feed.action.definitionAccessRevoked': 'Zugriff auf Ablauf widerrufen',
  'feed.action.definitionAdopted': 'Definition übernommen',
  'feed.action.definitionForked': 'Definition abgezweigt',
  'feed.action.definitionLinked': 'Zuordnung angegeben',
  'feed.action.definitionUnlinked': 'Zuordnung entfernt',
  'feed.action.annotationChanged': 'notiert',
  'feed.action.itemPinned': 'zum Board hinzugefügt',
  'feed.action.itemUnpinned': 'vom Board gelöst',
  'feed.action.flowJoined': 'in Ablauf aufgenommen',
  'feed.action.flowLeft': 'aus Ablauf herausgenommen',
  'feed.action.flowAdvanced': 'im Ablauf vorgerückt',
  'feed.action.flowStageMoved': 'Phase gewechselt',
  'feed.action.flowWaived': 'Bedingung erlassen',
  'feed.action.flowConditionAdded': 'Bedingung hinzugefügt',
  'feed.action.elevated': 'Eingriffsmodus eingeschaltet',
  'feed.action.deElevated': 'Eingriffsmodus beendet',
  'feed.action.decisionRecorded': 'Entscheidung festgehalten',
  'feed.action.ceremonyConvened': 'Besprechung einberufen',
  'feed.action.ceremonyItemAdded': 'Entscheidung auf die Tagesordnung gesetzt',
  'feed.action.ceremonyItemExecuted': 'Entscheidung umgesetzt',
  'feed.action.ceremonyItemDeclined': 'Entscheidung abgelehnt',
  'feed.action.ceremonyClosed': 'Besprechung beendet',
  'feed.action.ceremonyRosterChanged': 'Rolle in Besprechung geändert',
  'feed.action.inviteCreated': 'per E-Mail eingeladen',
  'feed.action.inviteRevoked': 'Einladung widerrufen',
  'feed.action.inviteClaimed': 'per Einladung beigetreten',
  'feed.action.inviteExpired': 'Einladung verfallen lassen',
  'feed.action.machineKeyMinted': 'Agentenschlüssel erstellt',
  'feed.action.machineKeyRevoked': 'Agentenschlüssel widerrufen',
  'feed.action.childrenReordered': 'Unteraufgaben umsortiert',
  'feed.action.closeDeferred': 'Abschluss aufgeschoben',
  'feed.action.closeDeferralRetracted': 'Aufschub zurückgenommen',
  'feed.action.itemTagged': 'Tag gesetzt',
  'feed.action.itemUntagged': 'Tag entfernt',
  'feed.action.attachmentAdded': 'Datei hinzugefügt',
  'feed.action.attachmentRemoved': 'Datei entfernt',
  'feed.action.attachmentCollected': 'Dateiinhalt gelöscht',

  'feed.event.created': '{actor} hat dies erstellt {detail}',
  'feed.event.statusChanged': '{actor} hat dies verschoben {detail}',
  'feed.event.committed': '{actor} hat zugesagt {detail}',
  'feed.event.phaseChanged': '{actor} hat dies verschoben {detail}',
  'feed.event.tendered': '{actor} hat die Arbeit eingereicht {detail}',
  'feed.event.tenderRetracted': '{actor} hat die Arbeit zurückgenommen {detail}',
  'feed.event.dissolved': '{actor} hat dies abgebrochen {detail}',
  'feed.event.revived': '{actor} hat dies wieder geöffnet {detail}',
  'feed.event.activityDeclared': '{actor} hat die Aktivität angegeben {detail}',
  'feed.event.concluded': '{actor} hat dies fertiggestellt {detail}',
  'feed.event.cancelled': '{actor} hat dies abgebrochen {detail}',
  'feed.event.reopened': '{actor} hat dies wieder geöffnet {detail}',
  'feed.event.seatOffered': '{actor} hat angeboten {detail}',
  'feed.event.seatTaken': '{actor} hat übernommen {detail}',
  'feed.event.seatDeclined': '{actor} hat abgelehnt {detail}',
  'feed.event.seatWithdrawn': '{actor} hat ein Angebot zurückgezogen {detail}',
  'feed.event.seatOfferAccepted': '{actor} hat ein Angebot angenommen {detail}',
  'feed.event.seatProposed': '{actor} hat {holder} {role} vorgeschlagen',
  'feed.event.seatAssigned': '{actor} hat {holder} {role} zugewiesen',
  'feed.event.seatAccepted': '{actor} hat {role} angenommen',
  'feed.event.seatAcceptedFor': '{actor} hat {role} für {holder} angenommen',
  'feed.event.seatTookUp': '{actor} hat {role} übernommen',
  'feed.event.seatRefused': '{actor} hat {role} abgelehnt',
  'feed.event.pushRuleSet': '{actor} hat Regeln zum Einsetzen festgelegt {detail}',
  'feed.event.reassigned': '{actor} hat neu eingesetzt {detail}',
  'feed.event.fieldChanged': '{actor} hat dies bearbeitet {detail}',
  'feed.event.contentEdited': '{actor} hat dies bearbeitet {detail}',
  'feed.event.commented': '{actor} hat kommentiert {detail}',
  'feed.event.acknowledged': '{actor} hat dies zur Kenntnis genommen {detail}',
  'feed.event.resolved': '{actor} hat die Bewertung zurückgenommen {detail}',
  'feed.event.accepted': '{actor} hat die Arbeit abgenommen {detail}',
  'feed.event.disputed': '{actor} hat die Abnahme verweigert {detail}',
  'feed.event.closed': '{actor} hat dies abgeschlossen {detail}',
  'feed.event.aborted': '{actor} hat dies abgebrochen {detail}',
  'feed.event.dependencyAdded': '{actor} hat eine Abhängigkeit hinzugefügt {detail}',
  'feed.event.dependencyRemoved': '{actor} hat eine Abhängigkeit entfernt {detail}',
  'feed.event.reparented': '{actor} hat dies verschoben {detail}',
  'feed.event.relationshipAdded': '{actor} hat dies verknüpft {detail}',
  'feed.event.relationshipRemoved': '{actor} hat eine Verknüpfung entfernt {detail}',
  'feed.event.relationshipProposed': '{actor} hat eine Verknüpfung angefragt {detail}',
  'feed.event.relationshipAccepted': '{actor} hat eine Verknüpfung angenommen {detail}',
  'feed.event.relationshipRejected': '{actor} hat eine Verknüpfung abgelehnt {detail}',
  'feed.event.shared': '{actor} hat freigegeben {detail}',
  'feed.event.unshared': '{actor} hat eine Freigabe widerrufen {detail}',
  'feed.event.accessRequested': '{actor} hat Zugriff angefragt {detail}',
  'feed.event.stageAdvanced': '{actor} hat dies in die nächste Phase vorrücken lassen {detail}',
  'feed.event.memberAdded': '{actor} hat ein Mitglied hinzugefügt {detail}',
  'feed.event.memberRemoved': '{actor} hat ein Mitglied entfernt {detail}',
  'feed.event.nestingProposed': '{actor} hat eine Unterordnung vorgeschlagen {detail}',
  'feed.event.nestingAccepted': '{actor} hat eine Unterordnung angenommen {detail}',
  'feed.event.nestingSevered': '{actor} hat eine Unterordnung aufgehoben {detail}',
  'feed.event.memberProposed': '{actor} hat eine Person gebeten beizutreten {detail}',
  'feed.event.memberAccepted': '{actor} ist beigetreten {detail}',
  'feed.event.memberDeclined': '{actor} hat den Beitritt abgelehnt {detail}',
  'feed.event.grantIssued': '{actor} hat Zugriff freigegeben {detail}',
  'feed.event.grantRevoked': '{actor} hat Zugriff widerrufen {detail}',
  'feed.event.moduleEnabled': '{actor} hat einen Abschnitt eingeschaltet {detail}',
  'feed.event.moduleDisabled': '{actor} hat einen Abschnitt ausgeschaltet {detail}',
  'feed.event.moduleAdded': '{actor} hat einen Abschnitt hinzugefügt {detail}',
  'feed.event.moduleRemoved': '{actor} hat einen Abschnitt entfernt {detail}',
  'feed.event.tagDefined': '{actor} hat einen Zustand definiert {detail}',
  'feed.event.tagApplied': '{actor} hat einen Zustand gesetzt {detail}',
  'feed.event.tagCleared': '{actor} hat einen Zustand aufgehoben {detail}',
  'feed.event.factQualified': '{actor} hat einen Fakt eingeordnet {detail}',
  'feed.event.factAdopted': '{actor} hat gesetzt {detail}',
  'feed.event.factContained': '{actor}: nicht betroffen von {detail}',
  'feed.event.factContainedAlone': '{actor}: nicht betroffen {detail}',
  'feed.event.flowFinding': '{actor} hat einen Befund zu einer Regel gemeldet {detail}',
  'feed.event.factCrossed': '{actor} hat eine Grenze überschritten {detail}',
  'feed.event.viewDefined': '{actor} hat ein Board oder eine Ansicht gespeichert {detail}',
  'feed.event.viewUpdated': '{actor} hat ein Board oder eine Ansicht aktualisiert {detail}',
  'feed.event.viewDeleted': '{actor} hat ein Board gelöscht {detail}',
  'feed.event.viewRetired': '{actor} hat ein Board oder eine Ansicht archiviert {detail}',
  'feed.event.viewRestored': '{actor} hat ein Board oder eine Ansicht wiederhergestellt {detail}',
  'feed.event.viewAccessGranted': '{actor} hat ein Board oder eine Ansicht geteilt {detail}',
  'feed.event.viewAccessRevoked':
    '{actor} hat das Teilen eines Boards oder einer Ansicht beendet {detail}',
  'feed.event.proposalCreated': '{actor} hat einen Vorschlag entworfen {detail}',
  'feed.event.proposalPublished': '{actor} hat einen Vorschlag veröffentlicht {detail}',
  'feed.event.proposalWithdrawn': '{actor} hat einen Vorschlag zurückgezogen {detail}',
  'feed.event.changeProposed': '{actor} hat eine Änderung vorgeschlagen {detail}',
  'feed.event.changeApplied': '{actor} hat eine Änderung angewendet {detail}',
  'feed.event.changeDeclined': '{actor} hat einen Änderungsvorschlag abgelehnt {detail}',
  'feed.event.changeSuperseded': '{actor} hat einen Änderungsvorschlag ersetzt {detail}',
  'feed.event.planCreated': '{actor} hat einen Plan erstellt {detail}',
  'feed.event.proposalAddedToPlan':
    '{actor} hat einen Vorschlag zu einem Plan hinzugefügt {detail}',
  'feed.event.planPublished': '{actor} hat einen Plan veröffentlicht {detail}',
  'feed.event.definitionDefined': '{actor} hat einen Ablauf definiert {detail}',
  'feed.event.definitionChanged': '{actor} hat eine Definition geändert {detail}',
  'feed.event.definitionArchived': '{actor} hat eine Definition archiviert {detail}',
  'feed.event.definitionUnarchived':
    '{actor} hat die Archivierung einer Definition aufgehoben {detail}',
  'feed.event.definitionAccessGranted': '{actor} hat Zugriff auf einen Ablauf freigegeben {detail}',
  'feed.event.definitionAccessRevoked': '{actor} hat Zugriff auf einen Ablauf widerrufen {detail}',
  'feed.event.definitionAdopted': '{actor} hat eine Definition übernommen {detail}',
  'feed.event.definitionForked': '{actor} hat eine Definition abgezweigt {detail}',
  'feed.event.definitionLinked': '{actor} hat eine Zuordnung angegeben {detail}',
  'feed.event.definitionUnlinked': '{actor} hat eine Zuordnung entfernt {detail}',
  'feed.event.annotationChanged': '{actor} hat notiert {detail}',
  'feed.event.itemPinned': '{actor} hat dies zum Board hinzugefügt {detail}',
  'feed.event.itemUnpinned': '{actor} hat dies vom Board gelöst {detail}',
  'feed.event.flowJoined': '{actor} hat dies in einen Ablauf aufgenommen {detail}',
  'feed.event.flowLeft': '{actor} hat dies aus einem Ablauf herausgenommen {detail}',
  'feed.event.flowAdvanced': '{actor} hat dies im Ablauf vorrücken lassen {detail}',
  'feed.event.flowStageMoved': '{actor} hat die Phase gewechselt {detail}',
  'feed.event.flowWaived': '{actor} hat eine Bedingung erlassen {detail}',
  'feed.event.flowConditionAdded': '{actor} hat eine Bedingung hinzugefügt {detail}',
  'feed.event.elevated': '{actor} hat den Eingriffsmodus eingeschaltet {detail}',
  'feed.event.deElevated': '{actor} hat den Eingriffsmodus beendet {detail}',
  'feed.event.decisionRecorded': '{actor} hat eine Entscheidung festgehalten {detail}',
  'feed.event.ceremonyConvened': '{actor} hat eine Besprechung einberufen {detail}',
  'feed.event.ceremonyItemAdded':
    '{actor} hat eine Entscheidung auf die Tagesordnung gesetzt {detail}',
  'feed.event.ceremonyItemExecuted': '{actor} hat eine Entscheidung umgesetzt {detail}',
  'feed.event.ceremonyItemDeclined': '{actor} hat eine Entscheidung abgelehnt {detail}',
  'feed.event.ceremonyClosed': '{actor} hat eine Besprechung beendet {detail}',
  'feed.event.ceremonyRosterChanged':
    '{actor} hat eine Rolle in einer Besprechung geändert {detail}',
  'feed.event.inviteCreated': '{actor} hat jemanden per E-Mail eingeladen {detail}',
  'feed.event.inviteRevoked': '{actor} hat eine Einladung widerrufen {detail}',
  'feed.event.inviteClaimed': '{actor} ist per Einladung beigetreten {detail}',
  'feed.event.inviteExpired': '{actor} hat eine Einladung verfallen lassen {detail}',
  'feed.event.machineKeyMinted': '{actor} hat einen Agentenschlüssel erstellt {detail}',
  'feed.event.machineKeyRevoked': '{actor} hat einen Agentenschlüssel widerrufen {detail}',
  'feed.event.childrenReordered': '{actor} hat die Unteraufgaben umsortiert {detail}',
  'feed.event.closeDeferred': '{actor} hat den Abschluss aufgeschoben {detail}',
  'feed.event.closeDeferralRetracted':
    '{actor} hat den aufgeschobenen Abschluss zurückgenommen {detail}',
  'feed.event.itemTagged': '{actor} hat einen Tag gesetzt {detail}',
  'feed.event.itemUntagged': '{actor} hat einen Tag entfernt {detail}',
  'feed.event.attachmentAdded': '{actor} hat eine Datei hinzugefügt {detail}',
  'feed.event.attachmentRemoved': '{actor} hat eine Datei entfernt {detail}',
  'feed.event.attachmentCollected': '{actor} hat den Inhalt einer Datei gelöscht {detail}',
} as const satisfies AreaCatalog<typeof en>;
